import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core';
import PropTypes from 'prop-types';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import Grid from "@material-ui/core/Grid";
import Icon from "../Icon"

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  breadcrumb_label_active: {
    fontSize: 16,
    lineHeight: '24px',
    fontWeight: 400,
    color: '#333333',
    paddingRight: 12,
    textTransform: 'capitalize',
  },
  breadcrumb_label_inactive: {
    fontSize: 16,
    lineHeight: '24px',
    fontWeight: 400,
    color: '#999',
    paddingRight: 12,
    textTransform: 'capitalize',
    '&:hover': {
      cursor: 'pointer',
      color: '#26BBED',
    },
  },
  forwardicon_active: {
    fontSize: 12,
    color: '#333',
    marginRight: 12,
  },
  forwardicon_inactive: {
    fontSize: 12,
    color: '#999',
    marginRight: 12,
  },
  option_class: {
    ...theme.typography.body1,
    fontSize: 16,
    color: theme.palette.black,
    fontWeight: 400,
    lineHeight: 1,
    height: "100%",
    margin: 0,
    cursor: "pointer",
    padding: "0px 10px",
    textOverflow: "ellipsis",
    overflow: "hidden",
    whiteSpace: "nowrap",
    flex: 1,
    width: 0,
    minWidth: "20px",
    "&:hover, &.active :hover": {
      textDecoration: "none",
      color: theme.palette.black
    },
    [theme.breakpoints.up("md")]: {
      padding: "0px 10px",
    }
  },
}));
const BreadCrumb = ({ allBreadcrumbs, xsWidth, onIconClick, onBreadcrumbClickedCallback }) => {
  const classes = useStyles();
  const last_path_index = (allBreadcrumbs || []).length - 1;
  const find_path = (index) => xsWidth && (allBreadcrumbs || [])[index];
  return (
    <div className={classes.root}>
      <div>{Boolean(xsWidth)}</div>
      <Grid container alignItems="center">
        {xsWidth && allBreadcrumbs.length>1? (
          <>
            <Icon
              onClick={onIconClick}
              type="icon-left-arrow"
              size="md"
            />
            <Typography
              variant="body1"
              key="top_nav_last_phrase"
              className={classes.option_class}
            >
              {find_path(last_path_index).label}
            </Typography>
          </>
        ) : allBreadcrumbs.map((breadcrumb, index) => (
          <>
            <Typography
              onClick={(e) => onBreadcrumbClickedCallback(e, breadcrumb)}
              className={
                breadcrumb.active_state
                  ? classes.breadcrumb_label_active
                  : classes.breadcrumb_label_inactive
              }
            >
              {breadcrumb.label}
            </Typography>
            {allBreadcrumbs.length - 1 !== index && (
              <ArrowForwardIosIcon
                className={
                  breadcrumb.active_state
                    ? classes.forwardicon_active
                    : classes.forwardicon_inactive
                }
              />
            )}
          </>
        ))}
      </Grid>
    </div>
  );
};

BreadCrumb.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  allBreadcrumbs: PropTypes.array.isRequired,
  onBreadcrumbClickedCallback: PropTypes.func.isRequired,
  xsWidth: PropTypes.bool,
  onIconClick: PropTypes.func.isRequired,
};

BreadCrumb.defaultProps = {};

export default BreadCrumb;